import { FormattedMessage as FM } from "react-intl";

import { classNames } from "tools/ui";

const style =
  "mx-auto bg-white py-2 h-12 text-center text-zinc-700 w-full border-b-8";

function InfoDoubleCard({ title, elements, color }) {
  function getItem(data) {
    return (
      <div key={data.name} className="grid grid-cols-1 pb-2 px-3">
        <div className="flex mx-auto">
          <span className="text-2xl font-semibold text-zinc-500">
            {data.value}
          </span>
          <span className="text-2xl font-semibold text-zinc-400 pl-1">
            {data.icon}
          </span>
        </div>
        <span className="flex mx-auto text-1xl text-zinc-700 mb-2 text-center">
          <FM id={data.name} />
        </span>
      </div>
    );
  }

  const _color = color ?? "border-amber-300";
  return (
    <div className="grid rounded-lg border border-neutral-100 shadow-lg w-1/4">
      <div className={classNames(style, _color)}>
        <span className="justify-center">
          <FM id={title} />
        </span>
      </div>
      <div className="grid grid-cols-2 mt-2">
        {elements && elements.map((element) => getItem(element))}
      </div>
    </div>
  );
}

export default InfoDoubleCard;
